// extracted by mini-css-extract-plugin
module.exports = {"svg":"style_svg__3L4yp","needsAttentionPulse":"style_needsAttentionPulse__c2f6-"};